import { render, staticRenderFns } from "./UserFeedbackDetail.vue?vue&type=template&id=ac56e814&scoped=true&"
import script from "./UserFeedbackDetail.vue?vue&type=script&lang=js&"
export * from "./UserFeedbackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac56e814",
  null
  
)

export default component.exports